import styled from "styled-components";

// z-index 10000 puts this above the PinnedNav (z-index: 9999)
export const Overlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(9, 30, 66, 0.54);
    z-index: 10000;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
    box-sizing: border-box;
`;

export const Panel = styled.div`
    position: relative;
    width: 100%;
    max-width: 420px;
    background: #fff;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
    max-height: 90vh;
    overflow-y: auto;
    box-sizing: border-box;
`;

export const CloseButton = styled.button`
    position: absolute;
    top: 12px;
    right: 12px;
    background: none;
    border: none;
    font-size: 16px;
    color: #888;
    cursor: pointer;
    padding: 4px 6px;
    border-radius: 4px;
    line-height: 1;

    &:hover {
        background: #f0f0f0;
        color: #333;
    }
`;

export const ModalBody = styled.div`
    padding: 4px 0 0;
    display: flex;
    flex-direction: column;
    gap: 20px;
`;

export const SectionTitle = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
`;

export const SectionLabel = styled.span`
    font-size: 13px;
    font-weight: 600;
    color: #333;
`;

export const Divider = styled.hr`
    border: none;
    border-top: 1px solid #ebebeb;
    margin: 0 0 10px;
`;

export const ToggleGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
`;

export const ToggleItem = styled.label`
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 12px;
    color: #444;
    cursor: ${({ disabled }) => (disabled ? "default" : "pointer")};
    opacity: ${({ disabled }) => (disabled ? 0.4 : 1)};
    pointer-events: ${({ disabled }) => (disabled ? "none" : "auto")};
    user-select: none;
`;

export const ToggleSwitch = styled.div`
    position: relative;
    width: 32px;
    height: 18px;
    border-radius: 999px;
    background: ${({ checked }) => (checked ? "#4a90e2" : "#d6d6d6")};
    flex-shrink: 0;
    transition: background 0.15s ease;

    &:after {
        content: "";
        position: absolute;
        top: 3px;
        left: ${({ checked }) => (checked ? "17px" : "3px")};
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background: #fff;
        transition: left 0.15s ease;
    }
`;

export const HiddenCheckbox = styled.input`
    position: absolute;
    opacity: 0;
    width: 0;
    height: 0;
`;

export const MasterToggleButton = styled.button`
    position: relative;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 8px;
    border-radius: 999px;
    border: 1px solid ${({ active }) => (active ? "#3a80d2" : "#e0e0e0")};
    background: ${({ active }) => (active ? "rgba(74,144,226,0.12)" : "#fafafa")};
    color: ${({ active }) => (active ? "#1f6fcf" : "#444")};
    font-size: 11px;
    cursor: pointer;
    transition: all 0.15s ease;

    &:hover {
        background: ${({ active }) => (active ? "rgba(74,144,226,0.18)" : "#f0f0f0")};
    }
`;

export const MasterToggleDot = styled.div`
    width: 16px;
    height: 9px;
    border-radius: 999px;
    background: ${({ active }) => (active ? "#4a90e2" : "#d6d6d6")};
    position: relative;
    transition: background 0.15s ease;

    &:after {
        content: "";
        position: absolute;
        top: 50%;
        left: ${({ active }) => (active ? "9px" : "2px")};
        transform: translateY(-50%);
        width: 5px;
        height: 5px;
        border-radius: 50%;
        background: #fff;
        transition: left 0.15s ease;
    }
`;

export const VoicePickerRow = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
`;

export const VoiceOption = styled.div`
    display: flex;
    align-items: center;
    padding: 8px 10px;
    border-radius: 8px;
    cursor: pointer;
    background-color: ${({ isActive }) => (isActive ? "rgba(74, 144, 226, 0.08)" : "transparent")};
    border: 1px solid ${({ isActive }) => (isActive ? "rgba(74, 144, 226, 0.3)" : "transparent")};
    transition: all 0.2s;

    &:hover {
        background-color: ${({ isActive }) =>
            isActive ? "rgba(74, 144, 226, 0.12)" : "rgba(0, 0, 0, 0.03)"};
    }
`;

export const AvatarCircle = styled.div`
    width: 34px;
    height: 34px;
    border-radius: 50%;
    background: ${({ isActive }) => (isActive ? "#4a90e2" : "#f0f0f0")};
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    flex-shrink: 0;
`;

export const AvatarImg = styled.img`
    width: 30px;
    height: 30px;
    object-fit: cover;
    border-radius: 50%;
`;

export const VoiceDetails = styled.div`
    display: flex;
    flex-direction: column;
    margin-left: 10px;
    flex: 1;
`;

export const VoiceName = styled.span`
    font-size: 13px;
    font-weight: 600;
    color: ${({ isActive }) => (isActive ? "#4a90e2" : "#222")};
    line-height: 1.25;
`;

export const VoiceDescription = styled.span`
    font-size: 11px;
    color: #666;
    margin-top: 1px;
`;

export const SampleButton = styled.button`
    display: inline-flex;
    align-items: center;
    gap: 5px;
    background-color: ${({ isPlaying }) => (isPlaying ? "#4a90e2" : "#f5f5f5")};
    color: ${({ isPlaying }) => (isPlaying ? "white" : "#444")};
    border: 1px solid ${({ isPlaying }) => (isPlaying ? "#3a80d2" : "#e6e6e6")};
    border-radius: 8px;
    padding: 5px 9px;
    font-size: 11px;
    cursor: pointer;
    transition: all 0.2s;
    margin-left: auto;

    &:hover {
        background-color: ${({ isPlaying }) => (isPlaying ? "#3a80d2" : "#ececec")};
    }
`;

export const ModalTitle = styled.h2`
    font-size: 15px;
    font-weight: 600;
    color: #222;
    margin: 0 0 16px;
    display: flex;
    align-items: center;
    gap: 8px;
`;
